module.exports = __webpack_public_path__ + "static/media/9.ff743f28.jpg";